import { createReducer, on } from '@ngrx/store';

import {
  clearPane,
  loadUserUiStateSuccess,
  setAsideMenuOpenedState,
  setMainHeaderHeight,
  setPane,
  setPBasketView,
  setPromotedLandingPageFeed,
  setUserMenuOpenedState,
  showLoaderOverlay,
  toggleAsideMenuOpenedState,
  toggleFeedView,
  toggleProductDetails,
  toggleWaitingNewOrder,
  updatePresetValue,
} from './actions/user-ui.actions';
import { PBasketView, State } from './model';

export const userUiFeatureKey = 'user-ui';

export const initialState: State = {
  asideMenuOpened: false,
  userMenuOpened: false,
  mainHeaderHeight: 0,
  singleColumnView: undefined,
  windowWidth: window.innerWidth,
  waitingNewOrder: false,
  presetFilter: null,
  overlaysOpened: 0,
  pBasketView: PBasketView.Tile,
  expandedProductDetails: true,
  panes: {
    right: {
      content: null,
    },
    fancyListEditMenu: {
      content: null,
    },
  },
  promotedLandingPageFeed: null,
};

export const reducer = createReducer(
  initialState,
  on(
    setAsideMenuOpenedState,
    (state, action): State => ({ ...state, asideMenuOpened: action.opened }),
  ),
  on(
    setUserMenuOpenedState,
    (state, action): State => ({ ...state, userMenuOpened: action.opened }),
  ),
  on(
    toggleAsideMenuOpenedState,
    (state): State => ({ ...state, asideMenuOpened: !state.asideMenuOpened }),
  ),
  on(
    loadUserUiStateSuccess,
    (state, action): State => ({ ...state, ...action.state }),
  ),
  on(
    setMainHeaderHeight,
    (state, action): State => ({ ...state, mainHeaderHeight: action.height }),
  ),
  on(
    setPromotedLandingPageFeed,
    (state, action): State => ({
      ...state,
      promotedLandingPageFeed: action.feed,
    }),
  ),
  on(
    toggleWaitingNewOrder,
    (state, { waitingNewOrder }): State => ({ ...state, waitingNewOrder }),
  ),
  on(
    toggleFeedView,
    (state, action): State => ({
      ...state,
      singleColumnView: action.singleColumnView,
    }),
  ),
  on(updatePresetValue, (state, { presetFilter }) => ({
    ...state,
    presetFilter,
  })),
  on(showLoaderOverlay, (state) => ({
    ...state,
    overlaysOpened: state.overlaysOpened + 1,
  })),
  on(showLoaderOverlay, (state) => ({
    ...state,
    overlaysOpened: state.overlaysOpened - 1,
  })),
  on(setPBasketView, (state, { pBasketView }) => ({
    ...state,
    pBasketView,
  })),
  on(toggleProductDetails, (state, { expanded }) => ({
    ...state,
    expandedProductDetails: expanded,
  })),
  on(setPane, (state, action) => {
    return {
      ...state,
      panes: {
        ...state.panes,
        [action.location]: {
          content: action.content,
          title: action.title,
          settings: action.settings,
        },
      },
    };
  }),
  on(clearPane, (state, action) => {
    return {
      ...state,
      panes: {
        ...state.panes,
        [action.location]: {
          content: null,
        },
      },
    };
  }),
);
